export function getLocaleString(locale) {
  let localeString = 'en';
  if (locale) {
    localeString = localeString + '-' + locale.toUpperCase();
  }
  return localeString;
}
